var React = require('react');

function Download (props) {
    return React.createElement("svg",props,[React.createElement("g",{"clipPath":"url(#clip0_888_128)","key":0},[React.createElement("path",{"d":"M3 12.0042V21H21V12","stroke":"#333333","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round","key":0}),React.createElement("path",{"d":"M16.5 11.5L12 16L7.5 11.5","stroke":"#333333","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round","key":1}),React.createElement("path",{"d":"M11.9958 3V16","stroke":"#333333","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round","key":2})]),React.createElement("defs",{"key":1},React.createElement("clipPath",{"id":"clip0_888_128"},React.createElement("rect",{"width":"24","height":"24","fill":"white"})))]);
}

Download.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = Download;

Download.default = Download;
